<template >
  <v-card id="collection-list">

    <v-toolbar
      color="primary"
      dark
      :loading="loading"
    >

    <v-tabs v-model="scopeIndex">
      <v-tab >
        Mine
      </v-tab>
      <v-tab >
        Shared
      </v-tab>
    </v-tabs>

   <div id="toolbar-actions"  :class="['d-flex','mr-0','ml-auto', 'flex-row', 'align-self-end', 'align-items-center']">
      <CollectionUploader />

    <v-tooltip
    bottom
   :nudge-top="tooltip.nudgeTop"
    :nudge-right="tooltip.nudgeRight"
    >

    <template v-slot:activator="{on:tooltip}">

      <v-btn
        icon
        x-small
        @click.stop="refresh"
        v-on ="{...tooltip}"
        class="flex-shrink-1"
      >
        <v-icon
        >mdi-refresh</v-icon>
      </v-btn>
    </template>
    <span>Refresh</span>
    </v-tooltip>


    </div>

    </v-toolbar>
    <v-card-text class='scroll'>
      <v-list>
        <v-list-item v-if="noMyCollections && collectionScope === 'mine'">
            <v-list-content>
                There are no files to display.
            </v-list-content>
        </v-list-item>
        <v-list-item v-if="noSharedCollections && collectionScope === 'shared_with_me'">
            <v-list-content>
                There are no shared files yet.
            </v-list-content>
        </v-list-item>

        <v-list-item
          :class ="itemClass(item)"
          v-for="item in collections"
          v-model="item.active"
          :key="item.id"
          :id="item.id"
          @click="expandCollection(item.id)"
          :append-icon="null"
          no-action
        >
            <v-icon :class="['mr-2', 'pl-0', 'pt-4', 'pb-4']">
                {{getFolderIcon(item)}}
            </v-icon>


                <div
                :key="form"
                >
                    <EditingForm v-if="form==item.id" :item="item" :update="update" :xSmall="true" @hideForm="form=''" route="collections" />
                </div>
                <div>
                    <div v-if="form!=item.id" :key="form">
                        <v-hover v-slot="{ hover }">
                            <v-list-item-title
                            :class ="['text-sm-body-2', 'text-wrap']"
                            v-text="item.name"
                            :title="myCollections.find(col=>col.id===item.id)?'Double-click to edit': ''"
                            @dblclick="showInput(item)"/>
                        </v-hover>
                    </div>

                    <v-list-item-subtitle  v-if="form!=item.id"
                    style="color: #999;"
                    class="text-caption"
                    v-text="formatDate(new Date(item.created_at))"
                    >
                    </v-list-item-subtitle>
                </div>

                <div :class="['d-flex', 'ml-auto', 'mr-0']">
                    <v-tooltip bottom>
                        <template v-slot:activator="{on, attrs}">
                            <v-btn
                            color="info"
                            icon
                            :disabled="item.download_url === null"
                            class="ml-1"
                            :href="item.download_url"
                            v-on="on"
                            v-bind="attrs"
                            x-small
                            >
                                <v-icon>
                                    mdi-download
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Download</span>
                    </v-tooltip>

                    <v-tooltip bottom
                    :nudge-top="tooltip.nudgeTop"
                    :nudge-right="tooltip.nudgeRight">
                        <template v-slot:activator="{on, attrs}">
                        <!-- wrapping button in div lets you add a tooltip in disabled state -->
                            <div v-on="on">
                                <v-btn
                                color="info"
                                icon
                                x-small
                                @click="showInput(item)"
                                v-on="on"
                                v-bind="attrs"
                                :disabled="pencilIsDisabled(item)"
                                >
                                    <v-icon>
                                        mdi-pencil
                                    </v-icon>
                                </v-btn>
                            </div>
                        </template>
                        <span>{{showMessage(item)? `Only owners can edit`: 'Edit'}}</span>
                    </v-tooltip>

                    <DeleteButton
                    route="collection"
                    :id="item.id"
                    color="info"
                    name="collection"
                    :disabled="deleteIsDisabled(item)"
                    :size="size"
                    />
                </div>


        </v-list-item>
      </v-list>
    </v-card-text>

  </v-card>
</template>
<script>
import DeleteButton from '@/components/DeleteButton.vue'
import CollectionUploader from '@/components/CollectionUploader.vue'
import EditingForm from '@/components/EditingForm.vue'
import { mapState } from 'vuex'
import { formatDate } from '@/utils/format'
import { startFileGeneration, update} from '@/utils/collections'
export default {
  name: 'CollectionList',
  components: {DeleteButton,
  CollectionUploader, EditingForm},
  computed: {
    activeItem: function() {
      return this.items.find(z => z.active === true)
    },

    ...mapState({
       // collections: 'collections',
        myCollections: 'myCollections',
        noMyCollections: 'noMyCollections',
        noSharedCollections: 'noSharedCollections',
        sharedCollections: 'sharedCollections',
        collection: 'collection',
        collectionId: 'collectionId',
        loading: 'loading',
        tooltip: 'tooltip',
        justGenerated: 'justGenerated',
        collectionScope: 'collectionScope'
       // startGenerationCheck: 'startGenerationCheck'

    }),
    collections(){
      return  this.collectionScope === 'mine'? this.cleanup(this.myCollections): this.cleanup(this.sharedCollections)
    }
  },

  watch: {
    scopeIndex(newVal) {
       if(newVal===0){
            this.$store.dispatch('updateState', ['collectionScope', 'mine'])
        }
        else if(newVal===1){
            this.$store.dispatch('updateState', ['collectionScope', 'shared_with_me'])
        }


    },
    collectionScope(newVal){
        switch(newVal){
            case 'mine':
                this.scopeIndex = 0;
                break;
            case 'shared_with_me':
                this.scopeIndex = 1;
                break;
        }
    },


    justGenerated(){

        this.$store.dispatch('updateState', ['collectionListRefreshedAt', Date.now()])
    },
    },

  mounted() {

    //clicking outside of card corresponding to item with form
    //will remove the form and turn it back to text element
    document.addEventListener('click',e=> {
        this.removeForm(e)});


    //window.setInterval(()=>this.color = undefined, 1000)
  },
  methods: {
     itemClass(item) {
        let itemClass = [item.id];
        if(item.active){
            itemClass.push('elevation-2')
        }
        else{
            itemClass.push('elevation-0')
        }
        if(this.collection.id === item.id){
            itemClass.push('selected')
        }
        return itemClass

    },
    hasForm(item){
        return this.form === item.id
    },
    notInMyCollections(item){
        //warning: if we enable navigating to "shared" tab without first passing through "mine" tab, we'll have to redefine this
        //ternary operator is to deal with vuetify being picky about types
        return !this.myCollections.find(x => x.id === item.id)? true: false
    },
    pencilIsDisabled(item){
        //disable edit button when either user isn't the owner of the collection or the form is already visible, so active "edit" button doesn't make sense
        return this.notInMyCollections(item) || this.hasForm(item)
    },
    showMessage(item){
        //message says "you can't delete shared collections"
       return this.notInMyCollections(item)
    },
    deleteIsDisabled(item){
        //you can still delete while actively editing, but you can't delete collections you don't own
        return this.notInMyCollections(item)
    },
    cleanup(arr){




        return arr.map(item => {

       return {...item,

          formId: `form-${item.id}`,
          titleId: `title-${item.id}`
         }
    })

    },
    expandCollection(id){
        //conditional to handle vue "redundant navigation" error message
        if(this.$route.params.collection_id !== id){
            this.$router.push({name: 'Collections', params: {collection_id: id}});
        }
        let item = this.collections.find(collection => collection.id === id);
        item.active = true;

    },
    showInput(item){

    if(this.myCollections.find(col=>col.id===item.id)){
      let id = item.id

      //display rename form instead of text
      //at selected item:
      this.form = id;

      //wait for input form to display,
      //then mark input text as selected:

      this.$nextTick(()=>{

        let input = document.querySelector(`#form-${id} input`)

        input.focus();
        input.select()})
         }
    },
    refresh() {
        //there's a watcher in /collections for this change in state
        //which triggers re-getting collections from database
        // you need this to handle case of navigating from /collections to /collections route
        //(otherwise the route watcher would handle it)

        this.$store.dispatch('updateState', ['collectionListRefreshedAt', Date.now()])
         this.$router.push({name: 'Collections'})
    },
    update(item){
        //go back to displaying collection title instead of input form:
        this.form = '';
      return update(item)
    },


    buttonLabel: function(item) {
      return item.download_generation_status == 'Generated' ? 'Re-generate' : 'Generate'
    },
    getFolderIcon(item) {
      //note: if the folder is shared, we are no longer displaying info about whether or not it's generating (shared icon supercedes clock icon)
      var icon = 'mdi-folder-outline'

      if(item.is_shared_with_account){
        icon = 'mdi-folder-account-outline'
      }
      else if (item.download_generation_status === 'Generated') {
        icon = 'mdi-folder-outline'
      }
      else if (item.download_generation_status === 'Generating') {
        icon = 'mdi-folder-clock-outline'
      }


      return icon
    },
    startFileGeneration: function(collection) {
      // const component = this
      startFileGeneration(collection.id).then(response => {
        collection.download_generation_status = 'Generating'
      })
    },
    formatDate: function(date, localeOptions, hideTime = false) {
      return formatDate(date, null, false)
    },

    removeForm(e){

      if(this.form){

      //each card has classname corresponding to item.id
      //this.form stores at most one item id
      //so we're finding the card containing the form
      //let parent = document.getElementsByClassName(this.form)[0]
      let parent = document.getElementById(this.form)

      //toggle form to text if clicking outside of form card:
      if(parent&&!parent.contains(e.target)&&parent!==e.target ){
        this.form = '';

      }
      }
    }
  },
  data: () => {
    return {
        green: true,
        size: {xSmall:true},
      //the id of the item which displays a rename form
      //'' if none
      form: '',
    navDark: true,
    items: [],
    contents: [],
    listState: null,
    scopeIndex: 0

  }
  }

}
</script>
<style scoped>

.selected {
     background-color: rgba(38, 169, 211, 0.25);
}
.scroll{
    overflow-y:scroll;
    max-height:80vh;
}
.no-padding >>> div {
    padding:0;
}
/* .v-card{
  max-width: 30vw;
} */


/* #toolbar-actions{
  margin-left:auto;
  margin-right:0;
} */
a {text-decoration: none;}
.v-subheader{
  margin-top: 20px;
  margin-bottom: 20px;
}

.v-subheader .v-btn{
  padding: 0;
}


#header-title{
  cursor: pointer;
}

/* .v-list-item__title{
  cursor: text;
} */

.text-cursor{
    cursor: text
}


@media only screen and (max-width: 1270px){
/* .v-subheader{flex-direction:column}  */
.v-btn{
  font-size:0.6rem;
}
}

@media only screen and (max-height:860px){
.scroll{
    max-height: 74.5vh;
}
}

@media only screen and (max-height:800px){
.scroll{
    max-height: 72vh;
}
}
@media only screen and (max-height:750px){
.scroll{
    max-height: 69.5vh;
}
}
</style>
